import { connect } from "react-redux";
import OverviewHeader from "../components/overview-header";
import {
    Container,
    Col,
    Row
} from "reactstrap";
import MessageBox from "src/modules/3rd-party-management/components/MessageBox";

const Communication = ({ organization }) => {
    return (
        <div className="page-content">
            <Container fluid>
                <Row>
                    <Col sm="12" className="mb-4">
                        <OverviewHeader className="tp-view" />
                    </Col>

                    <Col sm="12">
                        <MessageBox
                            settings={{
                                messageListUrl: '/supplier/comment/list',
                                sendMessageUrl: '/supplier/comment/add',
                                attachmentDownloadUrl: '/supplier/attachment/',
                                attachmentUploadUrl: '/supplier/attachment/upload',
                                attachmentDeleteUrl: '/supplier/attachment/',
                                supplierId: organization.id,
                                headerOptions: {
                                    displayFilters: false,
                                    title: 'Communication'
                                }
                            }}
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    const { Organization } = state;
    return {
        user: state.Login.user,
        token,
        organization: Organization
    };
};

export default connect(mapStatetoProps, {})(
    Communication
);